require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/fn/object/define-property.js
// module id = ../../../../core-js/library/fn/object/define-property.js
// module chunks = 7